import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, } from "react";
import { filterMessage, isData, isTokenMessage, listen, sendLocal, tokenRequestMessage, } from "@sinch/bus";
import { QueryClientProvider } from "@tanstack/react-query";
import { getQueryClient } from "./cacheHelpers";
export const TokenContext = createContext(undefined);
export const MFEProvider = ({ children, fallback, initToken, }) => {
    const [token, setToken] = useState(initToken ?? null);
    useEffect(() => {
        const unsub = listen(filterMessage(isTokenMessage)((message) => {
            const token = isData(message) ? message.payload : null;
            if (token) {
                setToken(token);
            }
        }));
        if (!initToken)
            sendLocal(tokenRequestMessage());
        return unsub;
    }, []);
    if (token === null) {
        return _jsx(_Fragment, { children: fallback });
    }
    return (_jsx(TokenContext.Provider, { value: token, children: _jsx(QueryClientProvider, { client: getQueryClient(), children: children }) }));
};
export function useToken() {
    const context = useContext(TokenContext);
    if (context === undefined) {
        throw new Error("useToken must be used within a TokenProvider");
    }
    return context;
}
